import { Show, SimpleShowLayout, useGetIdentity, useRefresh, useTranslate } from 'react-admin'
import Logo from './Logo'
import { HubConnection } from '@microsoft/signalr'

interface IProps {
  connection?: HubConnection
}

const UserLogo = ({connection}: IProps) => {

  const translate = useTranslate()
  const refresh = useRefresh()
  const { data: identity, isLoading } = useGetIdentity()

  connection?.on("UserUpdated", (user) => {
    refresh()
  })

  if(isLoading || !identity) return null

  return (
    <Show resource='users' id={identity.id} title={translate("resources.logo.name", {smart_count: 1})} actions={false} >
      <SimpleShowLayout>
        <Logo />
      </SimpleShowLayout>
    </Show>

  )
}

export default UserLogo